var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 60,
    viewBox: "0 0 51 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30723 59.6789C5.30723 59.6789 23.9437 60.4013 24.8332 59.6789C8.91897 45.881 5.16167 33.5623 14.6752 20.6408C14.6752 20.6408 13.3208 26.9228 16.481 30.5125C19.6413 34.1022 26.6391 33.2048 26.6391 33.2048L35.1041 36.1215C35.1041 36.1215 38.8287 36.7945 40.5217 34.551C42.2147 32.3074 40.2959 30.5125 40.2959 30.5125C40.2959 30.5125 35.4427 24.4549 33.0725 20.3043C30.7023 16.1537 30.1379 16.7146 30.1379 15.9293C30.1379 15.1441 43.6819 0 43.6819 0L25.6233 10.4326C14.5942 11.0276 9.03236 13.2457 0.702261 21.987L0.792554 54.7431C0.792554 54.7431 0.679688 56.9866 2.25982 58.2206C3.83996 59.4546 5.30723 59.6789 5.30723 59.6789ZM27.7677 22.8844C26.4649 20.9542 25.5343 20.0855 23.5917 18.846C23.5917 18.846 26.7519 17.8364 27.3163 19.519C27.8806 21.2017 27.7677 22.8844 27.7677 22.8844Z",
    fill: "#10273E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6233 10.4326C25.6233 10.4326 25.5825 9.60094 25.2847 9.19863C25.0021 8.81697 24.2689 8.52556 24.2689 8.52556H5.87156C1.99275 9.49035 1.06389 10.7666 0.679688 13.7979L0.702261 21.987C9.03236 13.2457 14.5942 11.0276 25.6233 10.4326Z",
    fill: "#DD2379"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3795 58.7815H46.0521C48.4676 58.2533 49.4533 57.4442 50.6797 55.1918V12.9005C50.4008 9.54158 49.1887 8.53481 45.8264 7.74031H39.0544C39.0544 7.74031 32.8467 13.5736 32.621 15.3684C32.3953 17.1633 42.8919 30.6247 42.8919 30.6247C42.8919 30.6247 43.7948 34.1022 40.7474 36.458C37.7 38.8137 35.8941 38.365 35.8941 38.365C35.8941 38.365 30.3637 37.5084 26.9777 35.6727C23.5917 33.8371 21.3343 34.8875 21.3343 34.8875C21.3343 34.8875 20.3185 35.4484 22.9145 45.5444C25.5104 55.6405 31.3795 58.7815 31.3795 58.7815Z",
    fill: "url(#paint0_radial_1017_7320)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8332 59.6789C25.7226 58.9565 25.1649 58.2613 24.9461 56.7623C24.7273 55.2633 21.8244 50.618 20.2056 46.8906C18.5869 43.1632 19.9799 37.2432 20.3185 36.1215C20.6571 34.9997 18.8512 35.4484 14.788 31.7465C10.7248 28.0446 14.6752 20.6408 14.6752 20.6408C5.16167 33.5623 8.91897 45.881 24.8332 59.6789Z",
    fill: "#10273E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1017_7320",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.6797 30) rotate(90) scale(30 25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D6899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10C6D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrLogo);
export default __webpack_public_path__ + "static/media/ur-logo.18aa615912bbd867294a276c96fdd66d.svg";
export { ForwardRef as ReactComponent };